import { User } from '../user';

import { getUserRole } from './get-user-role';

export const isUserAdmin = (user: User) => getUserRole(user) === 'admin';
